<template>
  <section class="page">
    <h1 class="title">
      <span v-if="userRole === 'user'">{{ $t('nav.welcome') }}</span>
      <span v-else>{{ $t('nav.quote') }}</span>
    </h1>

    <p class="message" v-if="userRole === 'admin' || userRole === 'translator'">
      {{ $t('nav.warning') }}
    </p>
  </section>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { getUser, getToken } from '@/utils/auth'
import { useI18n } from 'vue-i18n'

const router = useRouter()
const userRole = ref(null)
const { t } = useI18n()

onMounted(() => {
  const user = getUser()
  const token = getToken()

  if (!user || !token) {
    router.push({ path: '/login', query: { redirect: '/quote' } })
  } else {
    userRole.value = user.role

    if (user.role === 'user') {
      setTimeout(() => {
        router.push('/panel/user')
      }, 2000)
    }
  }
})
</script>


<style scoped>
.page {
  max-width: 800px;
  margin: 80px auto;
  padding: 40px;
  text-align: center;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}
.title {
  font-size: 1.8rem;
  margin-bottom: 1rem;
}

.message {
  font-size: 1rem;
  color: #ff4444;
  padding: 0 1rem;
}

@media (max-width: 600px) {
  .page {
    margin: 20px 10px;
    padding: 20px 10px;
  }

  .title {
    font-size: 1.4rem;
  }

  .message {
    font-size: 0.95rem;
  }
}
</style>
